/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconInfo12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconInfo12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path d="M6 4.5A.75.75 0 1 0 6 3a.75.75 0 0 0 0 1.5ZM6.625 5.002V9h-1.25V5.002h1.25Z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 1a5 5 0 1 0 0 10A5 5 0 0 0 6 1ZM3.172 3.172a4 4 0 1 1 5.656 5.656 4 4 0 0 1-5.656-5.656Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconInfo16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconInfo16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path d="M8 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM8.833 6.67V12H7.166V6.67h1.667Z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 1.333a6.667 6.667 0 1 0 0 13.334A6.667 6.667 0 0 0 8 1.334ZM4.228 4.23a5.333 5.333 0 1 1 7.543 7.542A5.333 5.333 0 0 1 4.228 4.23Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconInfo20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconInfo20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                d="M10 7.5A1.25 1.25 0 1 0 10 5a1.25 1.25 0 0 0 0 2.5ZM11.042 8.337V15H8.959V8.337h2.083Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 1.667a8.333 8.333 0 1 0 0 16.666 8.333 8.333 0 0 0 0-16.666ZM5.286 5.286a6.667 6.667 0 1 1 9.428 9.428 6.667 6.667 0 0 1-9.428-9.428Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconInfo24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconInfo24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path d="M12 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM13.25 10.005V18h-2.5v-7.995h2.5Z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20ZM6.343 6.343a8 8 0 1 1 11.314 11.314A8 8 0 0 1 6.343 6.343Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconInfo = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconInfo(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '12':
            return <IconInfo12 {...iconProps} />;
        case '16':
            return <IconInfo16 {...iconProps} />;
        case '20':
            return <IconInfo20 {...iconProps} />;
        case '24':
            return <IconInfo24 {...iconProps} />;
        default:
            return <IconInfo24 {...iconProps} />;
    }
});
